import {Flex} from "antd";
import {Game, getTextByLang, HeroBlock} from "./Game";
import {getLangFromUrl} from "./Header";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useSmartNavigate} from "./Main";

export const Hero = ({game, navigation}: { game?: Game, navigation?: boolean }) => {
    const lang = getLangFromUrl()
    const navigate = useSmartNavigate()

    return (
        getTextByLang(game?.hero?.image, lang) || getTextByLang(game?.hero?.background, lang) ?
        <div style={{position: 'relative'}}>
            <div className="hero-wrapper"
                 style={{
                     backgroundImage: game?.hero?.background ? `url(${getTextByLang(game.hero?.background, lang)})` : game?.hero?.image ? `url(${getTextByLang(game.hero?.image, lang)})` : 'none',
                     filter: game?.hero?.background ? 'none' : 'blur(80px)',
                     backgroundSize: game?.hero?.background ? 'cover' : 'cover',
                     backgroundPosition: 'center',
                     backgroundRepeat: 'repeat'

                 }}></div>
            <div className="hero"
                 style={{
                     backgroundImage: game?.hero?.image ? `url(${getTextByLang(game?.hero?.image, lang)})` : 'none',
                     backgroundSize: 'cover',
                     display: 'flex',
                     alignItems: 'end',
                     backgroundPosition: 'center'
                 }}>
                {navigation ?
                    <div style={{padding: 20, margin: "0 auto", width: "100%", maxWidth: 1200}}>
                        <Flex className="hero-buttons-wrapper" gap={10} align={'center'}>
                            <div className={"hero-buttons-border"}></div>
                            <Flex className="hero-buttons" gap={10} align={'center'}>
                                <Flex className="game-hero__title" style={{width: "100%"}} vertical={true}>
                                    <div>{getTextByLang(game?.name, lang)}</div>
                                    <div className="game-hero__text">
                                        {getTextByLang(game?.description, lang) &&
                                            <p className="game-hero__subtitle">{getTextByLang(game?.description, lang)}</p>}
                                    </div>
                                </Flex>
                                <Flex gap={10}>
                                    {game?.hero?.buttons?.map((btn, idx) => (
                                        <button
                                            key={idx}
                                            onClick={() => {
                                                navigate(getTextByLang(btn.link, lang))
                                            }}
                                            className={btn.type === 'secondary' ? 'game-slide__secondary' : 'game-slide__primary'}>
                                            {getTextByLang(btn.text, lang)}
                                        </button>
                                    ))}
                                </Flex>
                            </Flex>
                        </Flex>
                    </div>
                    : ''}
            </div>
        </div> : <div style={{height: 180, minHeight: 180}} className={'flow-wrapper'}></div>
)
}